import React from "react";
import PropTypes from "prop-types";

import Divider from "ui/Divider";
import { FormGroupTitle, FormSwitchField, FormTextField } from "ui/Form";

const AddEditAccountFields = ({ editDialog = false }) => {
  return (
    <>
      <FormGroupTitle title="Account information" />
      <FormTextField name="name" label="System name" />
      <FormTextField name="description" label="Description" />
      <div className="dialog-content-row">
        <FormTextField name="pmn_amount" label="Max. instances" type="number" />
      </div>
      {editDialog && <FormSwitchField name="enabled" label="Enabled" />}
      <Divider />
      <FormGroupTitle title="Credentials" />
      <FormTextField
        name="ipmp_user"
        label="Username"
        disabled={editDialog}
        autoComplete="new-password"
      />
      <div className="dialog-content-row">
        <FormTextField
          name="password"
          label="Password"
          type="password"
          autoComplete="new-password"
        />
        <FormTextField
          name="confirm_password"
          label="Confirm password"
          type="password"
        />
      </div>
    </>
  );
};

AddEditAccountFields.propTypes = {
  editDialog: PropTypes.bool,
};

export default AddEditAccountFields;
